<template>
  <div class="hacker_layout">
    <div v-wechat-title="'上线黑客活动-时光旅行社'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-travel' v-show='preloadingShow'></div>
    </transition>

    <!-- 主体页面 -->
    <div class="hacker_main">
      <div class="desk">
        <div class="time_box">{{ hours }}<span>:</span>{{ minutes }}</div>
        <div class="date_box">{{ date }} {{ week }}</div>
        <p v-if="userInfo.role_id" class="greeting">欢迎您管理员<b>{{ userInfo.role_name }}</b>, 当前权限等级<span>Lv.{{ level }}</span></p>

        <div class="content_app_list">
          <ul class="row_1">
            <li class="icon_sprite is_icon_1" @click="openPopup('goldCoinShow', true, '疯灵月影按钮[主页]')"></li>
            <li class="icon_sprite is_icon_2" @click="openPopup('secretShow', true, '密令破解按钮[主页]')"></li>
            <li class="icon_sprite is_icon_3" @click="openPopup('generationSecretShow', true, '口令生成器按钮[主页]')"></li>
          </ul>
          <ul class="row_2">
            <li class="icon_sprite is_icon_4" @click="openPopup('powerShow', true, '提升权限按钮[主页]')"></li>
            <li class="icon_sprite is_icon_5" @click="onJumpPage('内部攻略按钮[主页]', 'https://tap.cn/uk8PFxGK?channel=rep-rep_5odkgjofpu7')"></li>
            <li class="icon_sprite is_icon_6" @click="onJumpPage('上线福利按钮[主页]', 'https://tap.cn/QOOZYA8s?channel=rep-rep_9ypqevlulqg')"></li>
          </ul>
          <ul class="row_3">
            <li class="icon_sprite is_icon_7" @click="openPopup('emailShow', true, '公司邮件按钮[主页]')"></li>
            <li class="icon_sprite is_icon_8" @click="accountManage()"></li>
            <li class="icon_sprite is_icon_9" @click="openPopup('secretExchangeShow', true, '口令兑换按钮[主页]')"></li>
          </ul>
        </div>

        <ul class="footer_app_list">
          <li class="icon_sprite is_icon_10" @click="onJumpPage('预约页链接按钮[主页]', 'https://qcg.ink/WdkWA3')"></li>
          <li class="icon_sprite is_icon_11" @click="openPopup('groupShow', false, '加入Q群按钮[主页]')"></li>
          <li class="icon_sprite is_icon_12" @click="onJumpPage('加入微信群按钮[主页]', wechatGroupLink)"></li>
          <li class="icon_sprite is_icon_13" @click="onJumpPage('关注公众号按钮[主页]', wechatOfficialAccount)"></li>
        </ul>
      </div>
      <Footer :gameName="gameName" />
    </div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>
    <Header
      v-if='true'
      :config='headerConfig'
      :isShowInfo='true'
      :isOnline='1' />

    <!-- 疯灵月影 -->
    <div class="gold_coin_wrap popup_wrap" v-show="goldCoinShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="gold_coin_box" v-show="goldCoinShow">
          <div class="title tb_sprite tb_title_1"></div>
          <div class="game_info">
            <div class="cover"></div>
            <div class="info">
              <p class="game_name_label">游戏进程名：</p>
              <p class="game_name">shiguanglvxingshe.apk</p>
              <p class="author">作者：<span>相信科学</span></p>
              <p class="version">版本号：<span>SGLXS0.0.1</span></p>
            </div>
          </div>

          <ul class="power_list">
            <li class="hacker_sprite hs_award_item_bg">
              <div class="power_item">
                <div class="left">
                  <div class="hacker_sprite hs_gold_coin">
                    <div v-if="goldList[0].isReceive" class="hacker_sprite hs_reward"></div>
                  </div>
                </div>
                <div class="middle">
                  <div class="hacker_sprite hs_power_level_icon"></div>
                  <p class="level">Lv.1</p>
                  <p class="label">金币数量</p>
                </div>
                <div class="right">
                  <input type="number" v-model="goldList[0].amount"
                    placeholder="修改范围1~99999"
                    :disabled="goldList[0].isReceive"
                    @input="checkMax(99999, 0)"
                    @focus="inputFocus()"
                    @focusout="inputFocusOut()">
                  <span class="hacker_sprite hs_corner_mark_1"></span>
                </div>
              </div>
            </li>
            <li class="hacker_sprite hs_award_item_bg">
              <div class="power_item">
                <div class="left">
                  <div class="hacker_sprite hs_gold_coin">
                    <div v-if="goldList[1].isReceive" class="hacker_sprite hs_reward"></div>
                  </div>
                </div>
                <div class="middle">
                  <div class="hacker_sprite hs_power_level_icon"></div>
                  <p class="level">Lv.2</p>
                  <p class="label">金币数量</p>
                </div>
                <div class="right">
                  <input type="number" v-model="goldList[1].amount"
                    placeholder="修改范围1~999999"
                    :disabled="goldList[1].isReceive"
                    @input="checkMax(999999, 1)"
                    @focus="inputFocus()"
                    @focusout="inputFocusOut()">
                  <span class="hacker_sprite hs_corner_mark_2"></span>
                </div>
              </div>
              <div v-if="goldList[1].isLock" class="mask hacker_sprite hs_award_item_mask">
                <div class="lock hacker_sprite hs_icon_lock"></div>
                <div class="text">
                  <p v-if="!goldList[1].isLevelReach">权限等级<span>Lv.2</span>解锁</p>
                  <p v-if="!goldList[1].isTimeReach">一级奖励领取后次日解锁</p>
                </div>
              </div>
            </li>
            <li class="hacker_sprite hs_award_item_bg">
              <div class="power_item">
                <div class="left">
                  <div class="hacker_sprite hs_gold_coin">
                    <div v-if="goldList[2].isReceive" class="hacker_sprite hs_reward"></div>
                  </div>
                </div>
                <div class="middle">
                  <div class="hacker_sprite hs_power_level_icon"></div>
                  <p class="level">Lv.3</p>
                  <p class="label">金币数量</p>
                </div>
                <div class="right">
                  <input type="number" v-model="goldList[2].amount"
                    placeholder="修改范围1~1999999"
                    :disabled="goldList[2].isReceive"
                    @input="checkMax(1999999, 2)"
                    @focus="inputFocus()"
                    @focusout="inputFocusOut()">
                  <span class="hacker_sprite hs_corner_mark_3"></span>
                </div>
              </div>
              <div v-if="goldList[2].isLock" class="mask hacker_sprite hs_award_item_mask">
                <div class="lock hacker_sprite hs_icon_lock"></div>
                <div class="text">
                  <p v-if="!goldList[2].isLevelReach">权限等级<span>Lv.3</span>解锁</p>
                  <p v-if="!goldList[2].isTimeReach">二级奖励领取后次日解锁</p>
                </div>
              </div>
            </li>
          </ul>

          <div class="btns">
            <div class="tb_sprite tb_claim_resources_btn" @click="onReward()"></div>
            <div class="tb_sprite tb_elevate_permission_btn" @click="openPopup('powerShow', false, '提升权限按钮[疯灵月影弹窗]')"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="goldCoinShow" @click="closePopup('goldCoinShow')"></div>
    </div>
    <!-- 密令破解 -->
    <div class="secret_wrap popup_wrap" v-show="secretShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="secret_box" v-show="secretShow">
          <div class="title tb_sprite tb_title_2"></div>
          <div class="tip"><span class="hacker_sprite hs_tip"></span>密令可以在游戏—个人设置—密令 中兑换</div>
          <div class="notice">
            <img class="card" src="https://download4.qcplay.com/h5-images/active/travel/hacker/work_card.png" alt="">
            <p>旅行者们，当你们看到这个报告时，《时光旅行社》的密令系统已经被我破解，这玩意就跟纸糊似的...</p>
            <p>官方生成了<span>100</span>条密令（天晓得他们生成这么多干嘛...），我也懒得一条条告诉你们，大概就是一些网络热梗、常见的密令礼包码，你们自己去试吧，连<span>VIP888</span>这种老掉牙的密令都有....		</p>
          </div>
          <div class="tb_sprite tb_decrypt_page_btn" @click="onJumpPage('前往密令破解专题页按钮[密令破解弹窗]', 'https://tap.cn/QiDHebTe?channel=rep-rep_0l9zmtocu4f')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="secretShow" @click="closePopup('secretShow')"></div>
    </div>
    <!-- 邮件列表 -->
    <div class="email_wrap popup_wrap" v-show="emailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="email_box" v-show="emailShow">
          <div class="title tb_sprite tb_title_5"></div>
          <div class="content">
            <ul>
              <li v-for="item in emailList" :key="item.id" class="hacker_sprite hs_email_bg" @click="openEmailDetail(item.id)">
                <h3>
                  <b>{{item.title}}</b><span v-if="item.isTop" class="hacker_sprite hs_top_icon"></span>
                </h3>
                <p>{{item.author}}<span>{{item.date}}</span></p>
              </li>
              <p>—— 没有更多了 ——</p>
            </ul>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="emailShow" @click="closePopup('emailShow')"></div>
    </div>
    <!-- 邮件详情 -->
    <div class="email_detail_wrap popup_wrap" v-show="emailDetailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="email_detail_box" v-show="emailDetailShow">
          <div class="title tb_sprite tb_title_5"></div>
          <div class="content">
            <div :class="'email_detail_' + emailIdx"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="emailDetailShow" @click="closePopup('emailDetailShow')"></div>
    </div>
    <!-- 口令生成器 -->
    <div class="generation_secret_wrap popup_wrap" v-show="generationSecretShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="generation_secret_box" v-show="generationSecretShow">
          <div class="title tb_sprite tb_title_3"></div>
          <div class="tip"><span class="hacker_sprite hs_tip"></span>想要什么奖励自己生成吧，好友也可以使用哦！</div>
          <div class="content">
            <ul>
              <li v-for="(item, index) in secretList" :key="item.id" class="hacker_sprite hs_secret_item_bg">
                <div v-if="item.isLock" class="mask hacker_sprite hs_secret_item_mask" @click="onToast('请前往提升权限')">
                  <div class="lock hacker_sprite hs_icon_lock"></div>
                  <p>权限等级<span>{{ item.title }}</span>解锁</p>
                </div>
                <div class="secret_item">
                  <div class="top">
                    <div class="left">
                      <div :class="'hacker_sprite hs_icon_level_' + item.level"></div>
                    </div>
                    <div class="right">
                      <p class="name">{{ item.name || '口令待生成' }}</p>
                      <ul>
                        <li :class="'hacker_sprite hs_prop_' + (item.prop[0] ? ('s_' + item.prop[0]) : 'select_icon' )" @click="openPropBox(index, 1)"></li>
                        <li :class="'hacker_sprite hs_prop_' + (item.prop[1] ? ('s_' + item.prop[1]) : 'select_icon' )" @click="openPropBox(index, 2)"></li>
                        <li :class="'hacker_sprite hs_prop_' + (item.prop[2] ? ('s_' + item.prop[2]) : 'select_icon' )" @click="openPropBox(index, 3)"></li>
                      </ul>
                    </div>
                    <div v-if="item.isShowProp" class="select_box hacker_sprite hs_secret_more_bg">
                      <div class="prop_mask" @click="closePropBox(index)"></div>
                      <div :class="'triangle hacker_sprite hs_secret_triangle triangle-' + propIdx"></div>
                      <ul>
                        <li class="hacker_sprite hs_prop_1" @click="selectProp(index, 1)"></li>
                        <li class="hacker_sprite hs_prop_2" @click="selectProp(index, 2)"></li>
                        <li class="hacker_sprite hs_prop_3" @click="selectProp(index, 3)"></li>
                        <li class="hacker_sprite hs_prop_4" @click="selectProp(index, 4)"></li>
                        <li class="hacker_sprite hs_prop_5" @click="selectProp(index, 5)"></li>
                      </ul>
                    </div>
                  </div>
                  <div class="bottom">
                    <div v-if="!item.isEdit && !item.isLock"  :id="'clipboard-egg-btn-' + (index + 1)"
                      class="tb_sprite tb_copy_secret_btn" @click="copySecret('#clipboard-egg-btn-' + (index + 1), index + 1)"
                      :data-clipboard-text="item.name"></div>
                    <div v-else class="tb_sprite tb_generate_password_btn" @click="renderSecret(index)"></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="tb_sprite tb_exchange_btn" @click="openPopup('secretExchangeShow', false, '前往口令兑换按钮[口令生成弹窗]')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="generationSecretShow" @click="closePopup('generationSecretShow')"></div>
    </div>
    <!-- 口令兑换 -->
    <div class="secret_exchange_wrap popup_wrap" v-show="secretExchangeShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="secret_exchange_box" v-show="secretExchangeShow">
          <div class="title tb_sprite tb_title_4"></div>
          <div class="tip"></div>
          <div class="content">
            <input type="text" placeholder="入口奖励口令"
              v-model="secretKey"
              @focus="inputFocus()"
              @focusout="inputFocusOut()" />
            <div class="tb_sprite tb_exchange_award_btn" @click="exchangeSecret()"></div>
            <p>当前权限<span>Lv.{{ level }}</span>，可兑换{{ level }}条口令，升级<span>Lv.3</span>累计可兑换<span>3</span>条口令。(当前已兑换{{activeInfo.count || 0}}条)</p>
            <div class="tb_sprite tb_upgrade_btn" @click="openPopup('powerShow', false, '提升权限按钮[兑换口令弹窗]')"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="secretExchangeShow" @click="closePopup('secretExchangeShow')"></div>
    </div>
    <!-- 口令兑换成功 -->
    <div class="exchange_success_wrap popup_wrap" v-show="exchangeSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="exchange_success_box" v-show="exchangeSuccessShow">
          <p>兑换成功</p>
          <ul>
            <li v-for="(item, index) in secretAward"
              :key="index"
              :class="'hacker_sprite hs_prop_' + item"></li>
          </ul>
        </div>
      </transition>
      <div class="close-bg" v-if="exchangeSuccessShow" @click="closePopup('exchangeSuccessShow')"></div>
    </div>
    <!-- 提升权限 -->
    <div class="power_wrap popup_wrap" v-show="powerShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="power_box" v-show="powerShow">
          <div class="title tb_sprite tb_title_6"></div>
          <div class="tip"><span class="hacker_sprite hs_tip"></span>这个防火墙有点厉害啊，再喊两个帮手试试</div>
          <div class="content">
            <div class="bg">
              <div class="user_1 hacker_sprite hs_avatar_active">
                <p>{{ userInfo.role_name }}</p>
                <img v-if="userInfo" :src="userInfo.avatar" alt="">
              </div>
              <div :class="'user_2 hacker_sprite hs_avatar_' + (friendList[0] ? 'active' : 'unlock')">
                <p v-if="friendList[0]" class="name">{{ friendList[0] && friendList[0].nickname }}</p>
                <p v-else><span>Lv.2</span>解锁</p>
                <img v-if="friendList[0]" :src="friendList[0].avatar" />
              </div>
              <div :class="'user_3 hacker_sprite hs_avatar_' + (friendList[1] ? 'active' : 'unlock')">
                <p v-if="friendList[1]" class="name">{{ friendList[1] && friendList[1].nickname }}</p>
                <p v-else><span>Lv.3</span>解锁</p>
                <img v-if="friendList[1]" :src="friendList[1].avatar" />
              </div>
            </div>
            <h3>欢迎您管理员<b v-if="userInfo.role_name && (userInfo.role_name.length <= 3)">{{ userInfo.role_name }}</b>，当前权限等级<span>Lv.{{ level }}</span></h3>
            <div class="link">
              <p>https://h5.qingcigame.com/travel/hacker/enter51dfsdfa</p>
            </div>
          </div>
          <div class="tb_sprite tb_share_btn" id="clipboard-link-btn" :data-clipboard-text="'《时光旅行社》防火墙已破解，资源调整为999999，点击链接领取：' + helpLink" @click="copyHelpLink()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="powerShow" @click="closePopup('powerShow')"></div>
    </div>
    <!-- 助力弹窗 -->
    <div class="help_wrap popup_wrap" v-show="helpShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help_box" v-show="helpShow">
          <div class="cancel_btn"  @click="closePopup('helpShow')"></div>
          <div class="confirm_btn" @click="onHelp()"></div>
        </div>
      </transition>
    </div>
    <!-- 加群弹窗 -->
    <div class="group_wrap popup_wrap" v-show="groupShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="group_box" v-show="groupShow">
          <img src="https://download4.qcplay.com/h5-images/active/travel/hacker/group_popup.png" alt="加群弹窗">
          <div class="confirm_btn" @click="closePopup('groupShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="groupShow" @click="closePopup('groupShow')"></div>
    </div>
    <!-- 新手引导 -->
    <div class="guide_wrap popup_wrap" v-show="guideShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="guide_box" v-show="guideShow" @click="closePopup('guideShow')">
          <p>{{ dialogueText1 }}</p>
          <p>{{ dialogueText2 }}</p>
          <p>{{ dialogueText3 }}</p>
          <p>{{ dialogueText4 }}</p>
        </div>
      </transition>
      <div class="close-bg" v-if="guideShow" @click="closePopup('guideShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { headerConfig } from '../headerConfig';
import { analysisParams, getRandomString, buriedLogger } from '@/utils/utils';
import { generateWikiLink } from '@/api/active';
import { onGetInitDataAPI, onGenerationSecretAPI, onExchangeSecretAPI, onRewardAPI, getHelpInfoAPI, onHelpAPI } from '../api';

import eruda from 'eruda';

const EMAIL_LIST = [
  {
    id: 4,
    title: '黑进去了吗？抓紧使用工具，权限随时可能失效！',
    author: '神秘的X',
    date: '2023.12.22',
    isTop: true,
  },
  {
    id: 3,
    title: 'X感荷官在线发牌，保真！点进来赚大钱！',
    author: '沙利文老师',
    date: '2023.12.19'
  },
  {
    id: 1,
    title: 'Petar让你做的项目做好了吗？',
    author: '猴子策划',
    date: '2023.12.20'
  },
  {
    id: 2,
    title: '最近服务器被攻击了，顶住...',
    author: '大大大薏米',
    date: '2023.12.21'
  },
];

export default {
  name: 'demo',
  components: {
    Header,
    Footer,
    Login,
    Os,
  },
  data () {
    return {
      headerConfig,
      gameName: 'travel',
      downloadUrl: 'https://sglxs.qingcitimes.com/',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      date: '',
      week: '',
      hours: '',
      minutes: '',
      dialogue: [
        "正在破解时光旅行社防火墙",
        "......",
        "......",
        "登陆成功！欢迎您，管理员！"
      ],
      dialogueText1: '',
      dialogueText2: '',
      dialogueText3: '',
      dialogueText4: '',

      goldCoinShow: false,  // 疯灵月影
      secretShow: false,  // 密令破解
      secretExchangeShow: false, // 密令兑换
      emailShow: false,  // 邮件列表
      emailDetailShow: false, // 邮件详情
      powerShow: false,  // 提升权限
      generationSecretShow: false, // 口令生成
      helpShow: false, // 助力弹窗
      exchangeSuccessShow: false,
      guideShow: false,
      guiding: false,
      groupShow: false,

      secretList: [
        { id: 1, level: 1, title: 'Lv.1', name: '', isShowProp: false, prop: [undefined, undefined, undefined], isEdit: false, isLock: true },
        { id: 2, level: 2, title: 'Lv.2', name: '', isShowProp: false, prop: [undefined, undefined, undefined], isEdit: false, isLock: true },
        { id: 3, level: 3, title: 'Lv.3', name: '', isShowProp: false, prop: [undefined, undefined, undefined], isEdit: false, isLock: true }
      ],
      goldList: [
        { id: 1, level: 1, isReceive: false, isLock: true, amount: '' },
        { id: 2, level: 2, isReceive: false, isLock: true, amount: '' },
        { id: 3, level: 3, isReceive: false, isLock: true, amount: '' },
      ],
      propIdx: null,
      emailIdx: null,
      level: 0,
      helpId: null,
      wechatGroupLink: null,
      wechatOfficialAccount: null,
      helpLink: null,
      secretKey: '',
      secretAward: [],
      friendList: [],

      // 活动数据
      emailList: EMAIL_LIST,
      emailId: null,
    }
  },
  beforeCreate () {
  },
  created () {    
    const params = analysisParams(window.location.href);
    // 等时间配置完之后，才开始渲染页面
    setTimeout(() => {
      // 关闭LOGO
      this.preloadingShow = false;
      // 解析query 是否免密登录
      this.helpId = params.helper_id || null;
      if (params.helper_id) {
        getHelpInfoAPI({ helper_id: params.helper_id }).then((response) => {
          this.onInitDataCallback({ ...response, needAccount: false });
          if ([200, 401].includes(response.code)) {
            this.helpShow = true;
          }
        });
      } else {
        onGetInitDataAPI().then(response => {
          // 是否需要引导
          const needGuide = !localStorage.getItem('need_guide');
          this.onInitDataCallback({ ...response, needAccount: !needGuide });

          if ([200, 401].includes(response.code) && needGuide) {
            this.starGuide();
          }
        });
      }
    }, 1100);
    // 埋点
    const bl = buriedLogger('travel', '上线黑客活动');
    this.logger = bl;

    // 清空store上的用户数据
    setTimeout(() => {
      this.setInitActiveInfo();
      this.setInitUserInfo();
    }, 200);
    
    // 时间配置
    this.setClock();
    
    // 生成一键加群的链接
    this.onGenerationWiki();

    this.wechatShare();
  },
  mounted () {
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.clearData();
        } else {

          this.level = this.activeInfo.level;
          this.secretList = this.secretsHandle(this.activeInfo.code_info);
          this.goldList = this.goldsHandle(this.activeInfo.reward_info);
          this.friendList = this.activeInfo.friend_list || [];
          this.helpLink = `https://h5.qingcigame.com/travel/hacker/enter${getRandomString()}?helper_id=${newValue.user_id}`
        }
      }
    }
  },
  methods: {
    // 清除data里面相关数据
    clearData() {
      this.secretList = [
        { id: 1, level: 1, title: 'Lv.1', name: '', isShowProp: false, prop: [undefined, undefined, undefined], isEdit: false, isLock: true },
        { id: 2, level: 2, title: 'Lv.2', name: '', isShowProp: false, prop: [undefined, undefined, undefined], isEdit: false, isLock: true },
        { id: 3, level: 3, title: 'Lv.3', name: '', isShowProp: false, prop: [undefined, undefined, undefined], isEdit: false, isLock: true },
      ];
      this.emailId = null;
      this.level = 0;
      this.helpLink = null;
      this.goldList = [
        { id: 1, level: 1, isReceive: false, isLock: true, amount: '' },
        { id: 2, level: 2, isReceive: false, isLock: true, amount: '' },
        { id: 3, level: 3, isReceive: false, isLock: true, amount: '' },
      ];
      this.friendList = [];
    },
    // 选择角色后
    selectCallback () {
      // 初始化
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {},
    // 开启新手引导
    starGuide () {
      setTimeout(() => {
        this.guiding = true;
        this.guideShow = true;
        setTimeout(() => {
          this.displayTextByLetter(this.dialogue[0], 0);
        }, 1000);
      }, 1300);
    },
    // 设置时间
    setClock () {
      const today = new Date();
      const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '周五', '周六'];
      let day = today.getDate(), month = today.getMonth() + 1;
      this.date = `${month}月${day}日`;
      this.week = week[today.getDay()];
      const getTimer = () => {
        const curTimer = new Date();
        const hours = curTimer.getHours();
        const minutes = curTimer.getMinutes();
        const curDay = curTimer.getDate();
        if (curDay !== day) {
          month = today.getMonth() + 1;
          day = curDay;
          this.date = `${month}月${day}日`;
          this.week = week[curTimer.getDay()];
        }
        this.hours = hours > 9 ? hours : `0${hours}`;
        this.minutes = minutes > 9 ? minutes : `0${minutes}`;
      };
      getTimer();

      setInterval(() => {
        getTimer();
      }, 1000);
    },
    secretsHandle (list) {
      const secretList = [];
      list.forEach((item, index) => {
        const isLock = !item._get; // 是否锁定
        const isEdit = !isLock && !item.is_get;  // 不锁定 && 未领取
        const id = index + 1;
        secretList.push({
          id,
          level: id,
          title: `Lv.${id}`,
          name: item.code || '',
          isShowProp: false,
          prop: item.prop_list.length === 3 ? item.prop_list : [undefined, undefined, undefined],
          isEdit,
          isLock
        })
      });
      return secretList;
    },
    goldsHandle (list) {
      const goldList = [];
      const golds = [99999, 999999, 1999999];
      list.forEach((item) => {
        goldList.push({
          id: item.number,
          level: item.number,
          isReceive: item.is_get,
          isLevelReach: item.is_level_reach,
          isTimeReach: item.is_time_reach,
          isLock: !item._get,
          amount: item.is_get ? golds[item.number - 1] : ''
        });
      });
      return goldList;
    },
    displayTextByLetter(paragraph, index) {
      let i = 0;
      const interval = setInterval(() => {
        if (i <= paragraph.length) {
          this[`dialogueText${index + 1}`] = paragraph.slice(0, i);
          i++;
        } else {
          clearInterval(interval);
          if (index !== 3) {
            const intervalTime = [200, 600, 1400];
            setTimeout(() => {
              this.displayTextByLetter(this.dialogue[index + 1], index + 1);
            }, intervalTime[index]);
          } else {
            localStorage.setItem('need_guide', 1);
            setTimeout(() => { this.guiding = false; }, 500);
          }
        }
      }, 100); // 每个字之间的间隔时间
    },
    onGenerationWiki () {
      const wechat_group = localStorage.getItem('wechat_group_1');
      const wechat_official_account = localStorage.getItem('weChat_official_account_1');
      // 微信加群链接赋值
      if (!wechat_group) {
        generateWikiLink({ path: '/pages/game/group/group', q: 'a=35', version: 'release' })
          .then((res) => {
            const open_like = res.data.open_like;
            this.wechatGroupLink = open_like;
            window.localStorage.setItem("wechat_group_1", open_like);
          });
      } else {
        this.wechatGroupLink = wechat_group;
      }

      // 微信公众号链接加群
      if (!wechat_official_account) {
        generateWikiLink({ path: '/pages/game/wechat/wechat', q: 'a=35', version: 'release' })
          .then((res) => {
            const open_like = res.data.open_like;
            this.wechatOfficialAccount = open_like;
            window.localStorage.setItem("weChat_official_account_1", open_like);
          });
      } else {
        this.wechatOfficialAccount = wechat_official_account;
      }
    },
    copySecret (idName, idx) {
      this.onCopy(idName);
      this.logger.sum(`上线黑客活动_复制口令[${idx}]`);
    },
    copyHelpLink () {
      this.onCopy("#clipboard-link-btn");
      this.logger.sum(`上线黑客活动_复制助力链接`);
    },
    onHelp () {
      if (!this.helpId) {
        this.onToast('无效助力链接');
        return false;
      }
      onHelpAPI({ helper_id: this.helpId }).then((response) => {
        if (response.code === 200) {
          this.onToast('助力成功');
          this.helpShow = false;
        } else {
          this.onToast(response.message);
        }
      });
      this.logger.sum(`上线黑客活动_助力按钮`);
    },
    onReward () {
      const idx = this.goldList.reduce((result, item, index) => {
        if (item.isLevelReach && item.isTimeReach) {
          return index;
        }
        return result;
      }, 0);
      console.log('idx', idx)
      const curReward = this.goldList[idx];
      const nextReward = this.goldList[idx + 1] || [];
      console.log('curReward', curReward)
      if (curReward.level === 3 && curReward.isReceive) {
        this.onToast('代码已经全部破解');
        return false;
      }

      if (!curReward.isReceive) { // 未领取
        if (!curReward.amount) {
          this.onToast('请输入金额');
          return false;
        }
        onRewardAPI().then((response) => {
          this.goldCoinShow = false;
          this.onToast('领取成功');
          onGetInitDataAPI().then((res) => this.onInitDataCallback(res));
        });
      } else { // 已经领取
        if (curReward.level !== 3) {
          if (!nextReward.isLevelReach) {
            this.onToast('权限等级不足，快去提升权限吧');
          }
          if (!nextReward.isTimeReach) {
            this.onToast('代码破译中，明天再来吧');
          }
        } else {
          this.onToast('代码已经全部破解');
        }
      }
    },
    openEmailDetail (id) {
      this.emailIdx = id;
      this.openPopup("emailDetailShow", false, `前往邮件[${id + 1}]详情`);
    },
    openPropBox (secretIdx, propIdx) {
      const secretList = this.secretList;
      if (!secretList[secretIdx].isEdit) { // 不可编辑
        return false;
      }
      secretList[secretIdx].isShowProp = true;
      this.secretList = [...secretList];
      this.propIdx = propIdx;
    },
    selectProp (secretIdx, propId) {
      const secretList = this.secretList;
      secretList[secretIdx].prop[this.propIdx - 1] = propId;
      secretList[secretIdx].isShowProp = false;
      this.secretList = [...secretList];
      this.propIdx = null;
    },
    closePropBox (secretIdx) {
      const secretList = this.secretList;
      secretList[secretIdx].isShowProp = false;
      this.secretList = [...secretList];
      this.propIdx = null;
    },
    renderSecret (secretIdx) {
      const prop = this.secretList[secretIdx].prop;
      if (prop.includes(undefined)) {
        this.onToast('请先选择奖励');
        return false;
      }
      // 判断是否选择的奖励重复
      const isRepeat = this.secretList.filter(secret => secret.name)
        .reduce((result, secret) => {
          if (result) {
            return result;
          }
          const secretProp = [...secret.prop].sort((a,b) => a - b);
          const curProp = [...prop].sort((a,b) => a - b);
          // console.log('secretProp', secretProp, 'curProp', curProp);
          return secretProp.join(',') === curProp.join(',');
        }, false);
        // console.log('cccc', isRepeat);
      if (isRepeat) {
        this.onToast('组合重复，换个组合试试吧~');
        return false;
      }
      // 调用生成接口
      onGenerationSecretAPI({ prop_id: prop.join(','), number: this.secretList[secretIdx].level })
        .then(() => {
          this.onToast('密令生成成功');
          onGetInitDataAPI().then((res) => this.onInitDataCallback(res));
        });
      this.logger.sum(`上线黑客活动_生成口令[${secretIdx}]`);
    },
    onJumpPage (name, link) {
      if (!link) {
        this.onToast('敬请期待！');
        return false;
      }
      window.location.href = link;
      this.logger.sum(`上线黑客活动_${name}`);
    },
    accountManage () {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      this.changeOsPopup(true)
      this.logger.sum('上线黑客_账户管理按钮[主页]');
    },
    exchangeSecret () {
      if (!this.secretKey) {
        this.onToast('请输入奖励口令');
        return false;
      }
      if (this.activeInfo.count === 3) {
        this.onToast('兑换次数上限');
        return false;
      }
      onExchangeSecretAPI({ code: this.secretKey })
        .then((res) => {
          this.secretKey = '';
          this.secretAward = res.data.package_list;
          this.exchangeSuccessShow = true;
          onGetInitDataAPI().then(response => {
            this.onInitDataCallback(response);
          });
        });
    },
    // TAG: 其他简易封装的方法
    openPopup (name, isNeedLogin, tag) {
      if (isNeedLogin && !this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      this[name] = true;

      // 埋点
      if (tag) {
        this.logger.sum(`上线黑客活动_${tag}`);
      }
    },
    closePopup (name) {
      if (name === 'guideShow' && this.guiding) {
        return false;
      }
      if (name === 'guideShow' && !this.guiding) {
        onGetInitDataAPI().then(response => {
          this.onInitDataCallback(response);
        });
      }

      this[name] = false;

      if (name === 'secretExchangeShow') {
        this.secretKey = '';
      }
    },
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 复制
    onCopy (domName) {
      const clipboard = new Clipboard(domName);
      console.log('clipboard', clipboard)
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });

      clipboard.on('error', (e) => {
        console.log('e', e)
        this.onToast('复制失败');
      });
      this.logger.sum('anniversary_copy_link');
    },
    // 微信分享
    wechatShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/travel/hacker/enter${getRandomString()}`,
        title: '黑客行动，目标《时光旅行社》',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/aFRAFaBaBj7IP3W7Iq9QFrI1w5HjzAqLpo3vZLPL.png',
        desc: '这泼天的富贵，就让本黑客笑纳了'
      })
    },
    checkMax (maxVal, idx) {
      const goldList = this.goldList;
      const amount = Number(goldList[idx].amount);
      if (amount && amount > maxVal) {
        this.onToast('超过最大值');
        goldList[idx].amount = maxVal;
        this.goldList = goldList;
      }
    },
    // 移动端键盘调用
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
  @import url("./sprite.less");
  @import url("./icon_sprite.less");
  @import url("./title_btn_sprite.less");
</style>



// WEBPACK FOOTER //
// src/pages/travel/hacker/index/index.vue